var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSesameSeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00831 2.05653C1.24599 2.3672 1.48244 2.89792 1.53503 3.52895C1.58762 4.15999 1.32468 7.26296 3.79625 8.15693C8.15756 9.73453 8.29071 2.91768 4.7428 2.74016C3.69107 2.68757 2.67067 1.78652 2.00831 2.05653Z",
    fill: "#E5D9AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00831 2.05653C1.38324 2.31126 1.42986 2.71405 1.49587 3.19926C1.61783 1.2379 3.39719 3.00346 4.42766 3.00346C5.64796 3.00346 6.2693 3.68932 6.50016 4.89471C6.83097 6.62148 6.43788 7.72207 4.61674 7.74855C3.18274 7.76981 2.36038 6.60992 2.08626 5.97702C1.86547 5.46719 1.94565 4.35467 1.54361 3.73259C1.56337 4.65565 1.52757 7.33643 3.79625 8.15693C5.37421 8.72755 6.39872 8.19982 6.89549 7.2846L6.89474 7.28348C7.77156 5.67008 7.007 2.85316 4.7428 2.74016C3.69107 2.68757 2.67067 1.78652 2.00831 2.05653Z",
    fill: "#DEC98F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42628 3.05344C3.92156 3.07507 4.41684 3.29026 4.71819 3.63487C5.01953 3.97948 4.91212 5.29302 4.84723 6.08965C4.78271 6.88665 6.44086 7.70491 6.63479 6.08965C6.82873 4.47439 6.13951 3.20411 5.14895 2.96729C4.15838 2.73046 3.6631 2.73046 3.18945 2.51489C2.97538 2.41755 2.69081 2.32021 2.46294 2.28441C1.62603 2.15313 2.20336 3.00048 3.42628 3.05344Z",
    fill: "#EBE7B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3677 11.201C14.2438 10.3245 13.9704 9.09566 13.0447 9.10871C10.4949 9.14489 8.50255 8.75888 6.47927 11.3155C5.59314 12.4351 6.34538 13.859 7.79207 14.3028C9.50281 14.828 10.9995 13.984 12.0176 12.9389C12.6453 12.2949 12.4913 12.0774 13.3677 11.201Z",
    fill: "#DEC98F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25502 13.3902C7.93603 13.7796 9.39577 13.9254 10.5635 13.147C11.7312 12.3687 12.6558 11.59 12.6558 11.0548C12.6558 10.5196 13.2394 10.8116 13.5315 10.2764C13.8235 9.74124 13.6288 9.40073 12.5584 9.30339C10.8205 9.14563 8.91466 9.35672 7.55972 10.5412C6.4886 11.4777 5.97728 12.66 7.25502 13.3902Z",
    fill: "#E5D9AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88755 12.3198C8.17957 12.7092 8.71476 13.0497 9.63894 12.6119C10.5635 12.174 11.4392 11.3468 11.7312 10.8116C12.0232 10.2764 12.6558 10.6658 12.9474 10.0817C13.2066 9.56334 7.15842 11.3479 7.88755 12.3198Z",
    fill: "#EBE7B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4668 0.704951C12.8135 0.995109 12.3488 2.11621 12.4547 2.75135C12.5607 3.38649 13.0544 6.87957 10.9021 7.62025C8.74981 8.36131 7.86778 6.45589 7.93827 5.15056C8.00876 3.84522 9.27904 2.53951 9.63185 1.9398C9.98466 1.34009 10.5195 0.500946 11.4668 0.704951Z",
    fill: "#DEC98F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8671 0.951845C11.9475 0.46253 12.4197 1.41058 12.1373 2.15164C11.855 2.89269 10.3378 3.0691 9.77357 4.05706C9.20892 5.04501 8.89154 6.42121 9.42076 6.915C9.94998 7.40879 9.56173 7.62063 9.13843 7.26781C8.71513 6.915 7.83309 5.99753 8.4328 4.48036C9.03251 2.96318 10.0764 1.30951 10.8671 0.951845Z",
    fill: "#E5D9AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60884 5.11513C8.64427 5.67978 8.78524 6.27949 8.78524 5.92667C8.78524 5.57386 8.67933 5.08007 9.10263 4.23309C9.52593 3.38649 10.4434 2.25718 10.4434 2.25718C9.63595 1.98791 8.56707 4.44232 8.60884 5.11513Z",
    fill: "#EBE7B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90116 8.4967C3.48259 8.66639 3.57621 9.19412 3.70413 9.59803C3.74814 9.73677 3.79625 9.86096 3.86972 9.95084C5.55211 12.0073 5.45403 15.2128 2.65538 15.9125C2.21381 16.0229 0.594443 15.8756 0.152866 14.3301C-0.163026 13.2246 0.048439 11.9309 0.436683 11.0548C0.740268 10.3697 2.02285 8.24048 2.90116 8.4967Z",
    fill: "#DEC98F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90116 8.4967C3.27113 8.60448 3.44343 8.85771 3.55308 9.13146C3.13276 8.5821 2.79375 8.57501 2.4014 9.01547C2.00495 9.46078 1.62267 10.5312 1.44664 11.4773C0.855883 14.6538 3.9499 13.5129 3.22973 10.1966C3.2081 10.0978 3.21892 10.0228 3.2812 9.98739C3.44642 9.89303 3.73322 10.238 4.04389 10.6919C5.14783 12.3053 5.20116 15.0767 3.09733 15.544C2.76615 15.6175 2.78554 15.3602 2.34397 15.3232C1.90239 15.2863 1.84607 15.6175 1.47834 15.544C0.77719 15.4038 0.42624 14.6023 0.280416 13.994C-0.0365947 12.6719 0.937187 9.73826 2.02472 8.81892C2.3283 8.56196 2.63338 8.41875 2.90116 8.4967Z",
    fill: "#E5D9AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67787 9.50031C1.95535 9.06694 2.00719 9.2922 1.8513 9.535C1.6954 9.77779 1.14082 10.9213 1.07145 11.857C1.00208 12.7927 1.14082 13.5554 1.29671 13.9366C1.45261 14.3178 1.03676 14.8376 0.75966 14.1619C0.482556 13.4861 0.551552 12.2728 0.742132 11.3718C0.932711 10.4707 1.67787 9.50031 1.67787 9.50031Z",
    fill: "#EBE7B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91373 11.0428C4.31241 11.7709 4.48546 13.9717 3.94841 14.5087C3.41136 15.0458 3.23793 14.5087 3.44604 14.0582C3.65415 13.6076 4.31204 12.6891 3.91373 11.0428Z",
    fill: "#EBE7B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1757 5.71409C17.1655 5.94196 18.3082 6.33767 18.8677 6.88367C20.1655 8.15022 20.6586 10.4051 18.6461 11.1066C16.6046 11.8186 15.3414 9.96576 15.024 8.47059C14.8756 7.77167 14.8297 7.0791 14.5757 6.72293C14.2274 6.23473 14.3232 5.54067 14.6898 5.42393C15.2243 5.25387 15.0949 5.46533 16.1757 5.71409Z",
    fill: "#E5D9AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1757 5.71409C17.1487 5.93823 18.1229 6.35669 18.67 6.81206C18.7371 6.86801 19.5412 7.94883 18.8334 7.19061C18.56 6.89784 18.2019 6.5786 17.6794 6.47417C16.9473 6.32797 15.8624 5.88826 15.5144 5.74877C15.1665 5.60966 14.7141 5.57498 14.575 5.81852C14.4359 6.06205 15.0967 6.37534 15.1318 6.79267C15.2657 8.40122 16.0571 11.5758 18.4022 10.6546C19.2354 10.3272 19.608 9.42274 19.7292 8.90471C19.9339 9.77518 19.7173 10.7333 18.6461 11.1066C16.6046 11.8186 15.3414 9.96576 15.024 8.47059C14.8756 7.77167 14.8297 7.0791 14.5757 6.72293C14.2274 6.23473 14.3232 5.54067 14.6898 5.42393C15.2243 5.25387 15.0949 5.46533 16.1757 5.71409Z",
    fill: "#DEC98F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2362 6.16648C15.2896 6.13552 15.5622 6.23958 15.9284 6.41487C16.2555 6.57151 16.5796 6.62969 16.9675 6.85458C20.088 8.6634 17.6888 10.1041 16.9059 9.81956C15.8516 9.43616 16.1682 7.8843 15.6491 7.08245C15.4067 6.70838 15.0971 6.37533 15.2362 6.16648Z",
    fill: "#EBE7B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9272 17.301C14.183 17.2592 14.4799 17.1824 14.7831 17.0791C15.7565 16.7479 17.6108 15.3247 17.9028 14.4129C18.0453 13.9672 17.5463 13.379 16.869 13.3966C16.1917 13.4145 14.7118 13.0221 13.8205 13.3074C13.1413 13.5249 12.6434 13.8046 12.2962 14.1152C10.7183 15.5269 12.241 17.5762 13.9272 17.301Z",
    fill: "#DEC98F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1444 14.5382C11.8591 14.948 11.8949 15.2155 11.8591 15.3937C11.8233 15.572 12.0195 15.6078 12.1086 15.8752C12.1978 16.1426 11.9897 16.1683 12.1086 16.3388C12.7113 17.2018 13.9212 16.984 14.8364 16.6137C16.5885 15.9047 17.666 14.3491 16.6012 13.8609C15.162 13.2011 13.2465 13.0691 12.1444 14.5382Z",
    fill: "#E5D9AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4473 15.0726C12.2511 14.734 13.107 13.9851 13.606 13.7893C14.1688 13.5681 16.0899 13.5476 16.3693 14.1992C16.6579 14.8727 14.9804 16.2668 14.8539 15.8036C14.8006 15.6074 15.5491 15.1438 15.353 14.7161C14.8483 13.6147 12.8251 15.5134 12.4473 15.0726Z",
    fill: "#EBE7B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSesameSeeds);
export default __webpack_public_path__ + "static/media/sesame-seeds.3ea6db2f4173a5fd2c660ef4a568ab45.svg";
export { ForwardRef as ReactComponent };